module.exports = __webpack_public_path__ + "static/media/manutencao.3ef8deeb.png";